// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class EnrollPatientAccountAttestationAttribute {
    'code': string;
    'value'?: string;
    'startDate'?: Moment;
    'endDate'?: Moment;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof EnrollPatientAccountAttestationAttribute>> = [
        {
            "name":     "code",
            "baseName": "code",
            "type":     "string"
        },
        {
            "name":     "value",
            "baseName": "value",
            "type":     "string"
        },
        {
            "name":     "startDate",
            "baseName": "startDate",
            "type":     "Date"
        },
        {
            "name":     "endDate",
            "baseName": "endDate",
            "type":     "Date"
        },
    ];

    static getAttributeTypeMap() {
        return EnrollPatientAccountAttestationAttribute.attributeTypeMap;
    }
}
